import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faHome } from '@fortawesome/free-solid-svg-icons';

const Breadcrumb = ({ activeTab }) => {
  const getTabDisplayName = (tab) => {
    const tabNames = {
      'overview': 'Overview',
      'alerts': 'System Alerts',
      'metrics': 'Live Metrics',
      'logs': 'System Logs',
      'pipelines': 'Data Pipelines',
      'web-services': 'Web Services',
      'external-sources': 'External Sources',
      'debugging': 'Debugging Assistant'
    };
    return tabNames[tab] || 'Dashboard';
  };

  return (
    <div className="breadcrumb">
      <div className="breadcrumb-item">
        <FontAwesomeIcon icon={faHome} />
        <span>SPHEROID Dashboard</span>
      </div>
      <FontAwesomeIcon icon={faChevronRight} className="breadcrumb-separator" />
      <div className="breadcrumb-item active">
        <span>{getTabDisplayName(activeTab)}</span>
      </div>
    </div>
  );
};

export default Breadcrumb;